import { createFileRoute } from "@tanstack/react-router";
import { RouteGuard } from "@/components/RouteGuard";
import { ParentAssessmentsAdminIndex } from "@/lib/lazyPages";

export const Route = createFileRoute("/admin/parent-assessments/")({
  component: () => (
    <RouteGuard access={{ kind: "admin" }}>
      <ParentAssessmentsAdminIndex />
    </RouteGuard>
  ),
});
